<button type="button" mat-icon-button class="app-fr-trigger-btn" [class.app-fr-trigger-btn--active]="hasMatches"
    [matMenuTriggerFor]="menu" [matTooltip]="tooltip" [attr.aria-label]="tooltip"
    (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()" (click)="$event.stopPropagation()">
    <mat-icon>find_replace</mat-icon>
</button>

<mat-menu #menu="matMenu" [class]="'app-fr-menu ' + panelClass">
    <!-- Lazy: 20+ notes on a page would otherwise each build two form fields up front. -->
    <ng-template matMenuContent>
        <div class="app-fr-panel" (click)="$event.stopPropagation()" (keydown)="onKeydown($event)">

            <mat-form-field appearance="outline" class="app-fr-field">
                <mat-label>Find</mat-label>
                <input matInput #findInput class="app-fr-find" type="text" autocomplete="off" spellcheck="false"
                    [value]="find" (input)="onFindInput($event)">
                <span matSuffix class="app-fr-count">{{ countLabel }}</span>
            </mat-form-field>

            <mat-form-field appearance="outline" class="app-fr-field">
                <mat-label>Replace with</mat-label>
                <input matInput class="app-fr-replace" type="text" autocomplete="off" spellcheck="false"
                    [value]="replace" (input)="onReplaceInput($event)">
            </mat-form-field>

            <div class="app-fr-actions">
                <button type="button" mat-icon-button class="app-fr-nav" matTooltip="Previous match"
                    aria-label="Previous match" [disabled]="!hasMatches" (click)="previous.emit()">
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <button type="button" mat-icon-button class="app-fr-nav" matTooltip="Next match"
                    aria-label="Next match" [disabled]="!hasMatches" (click)="next.emit()">
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>

                <span class="app-fr-spacer"></span>

                <button type="button" mat-icon-button class="app-fr-nav"
                    [matTooltip]="undoTooltip" [attr.aria-label]="undoTooltip"
                    [disabled]="!canUndo" (click)="undo.emit()">
                    <mat-icon>undo</mat-icon>
                </button>

                <button type="button" mat-stroked-button class="app-fr-replace-all"
                    matTooltip="Replace every match in this field" [disabled]="!hasMatches || !canReplace"
                    (click)="replaceAll.emit()">
                    All
                </button>

                <button type="button" mat-stroked-button class="app-fr-replace-scope" *ngIf="hasScope"
                    matTooltip="Replace every match in every field, including sections that are not open"
                    [disabled]="!hasScopeMatches || !canReplace" (click)="replaceEverywhere.emit()">
                    {{ scopeLabel }}
                </button>
                <button type="button" mat-flat-button color="primary" [disabled]="!hasMatches || !canReplace"
                    (click)="replaceOne.emit()">
                    Replace
                </button>
            </div>

        </div>
    </ng-template>
</mat-menu>
